import React, { useEffect, useState } from 'react';
import { Alert, Drawer, Select, Space, Spin, Tag, Typography } from 'antd';
import { geoExposureApi } from './geoExposureApi';
import { AnswerCard } from './AnswerCard';
import { formatDate, RUN_STATUS_COLORS } from './GeoExposureLayout';

const { Text, Title } = Typography;

/**
 * Every rephrase of one query with its ChatGPT answer, for one run — and a
 * picker to read the same query's answers from the other runs.
 */
export const QueryAnswersDrawer = ({ queryId, queryText, runId, onClose }) => {
    const [history, setHistory] = useState(null);
    const [error, setError] = useState(null);
    const [selectedRunId, setSelectedRunId] = useState(runId);

    useEffect(() => {
        setHistory(null);
        setError(null);
        setSelectedRunId(runId);
        if (!queryId) return;
        geoExposureApi.getQueryHistory(queryId).then(setHistory).catch((e) => setError(e.message));
    }, [queryId, runId]);

    const current = history?.find((h) => h.runId === selectedRunId) ?? history?.[0];

    return (
        <Drawer open={!!queryId} onClose={onClose} size="large" title="Query answers">
            {queryId && (
                <Space direction="vertical" size={16} style={{ width: '100%' }}>
                    <Title level={5} style={{ margin: 0 }}>{queryText}</Title>
                    {error && <Alert type="error" showIcon message={error} />}
                    {!history && !error && <Spin />}
                    {history && (
                        <Space wrap>
                            <Text>Run</Text>
                            <Select
                                style={{ minWidth: 320 }}
                                value={current?.runId}
                                onChange={setSelectedRunId}
                                options={history.map((h) => ({
                                    value: h.runId,
                                    label: `${formatDate(h.runCreatedAt)} · ${h.mentioned}/${h.completed} mentioned${h.runStatus !== 'completed' ? ` · ${h.runStatus}` : ''}`,
                                }))}
                            />
                            {current && <Tag color={RUN_STATUS_COLORS[current.runStatus]}>{current.runStatus}</Tag>}
                            <Text type="secondary">{history.length} run{history.length === 1 ? '' : 's'} asked this query</Text>
                        </Space>
                    )}
                    {current && current.answers.map((answer) => <AnswerCard key={answer.id} answer={answer} />)}
                </Space>
            )}
        </Drawer>
    );
};
